import React, { Component } from 'react'
import { Card, Form, Col } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle } from '@fortawesome/free-regular-svg-icons';
import { faCircle as faSolidCircle }  from '@fortawesome/free-solid-svg-icons';



class WorksheetRadioList extends Component {
    constructor(props, context) {
        super(props, context);

        this.onChangeRadio = this.onChangeRadio.bind(this);
        this.onBlur = this.onBlur.bind(this);
    }

    onBlur(name, value) {
        let event = { target: { name: name, value: value } };
        this.props.onBlur(event);
    }

    onChangeRadio(name, currentValue, newValue) {
        let event = { target: { name: name, value: newValue }};
        if (currentValue === event.target.value) {
            event.target.value = undefined;
        }; 
        this.props.onChangeInput(event);     
    }

    render() {
        let lg = this.props.colLg ? this.props.colLg : 12;
        let md = this.props.colMd ? this.props.colMd : 12;

        if (this.props.print) {
            return (
                <Form.Group as={Col} lg={lg} md={md}>
                    <Form.Label>{this.props.label}</Form.Label><br />
                    {this.props.value}
                </Form.Group>
            );
        } else {
            return (
                <Form.Group as={Col} lg={lg} md={md} >
                    <Form.Label>{this.props.label}</Form.Label>
                    <br />
                    {this.props.masterQuestionOptions.map((opt, idx) => {
                        let checked = this.props.value === opt.optText;
                        return <span className="givemethefinger d-table" tabIndex="0" onBlur={() => this.onBlur(this.props.name, this.props.value)} onKeyPress={() => this.onChangeRadio(this.props.name, this.props.value, opt.optText)} onClick={() => this.onChangeRadio(this.props.name, this.props.value, opt.optText)}>

                            <FontAwesomeIcon icon={checked ? faSolidCircle : faCircle} />&nbsp;{opt.optText}
                            {
                                this.props.value === opt.optText && this.props.error ?
                                    <><br/><small className="text-danger">Initial and Revised values cannot be the same</small></> : null
                            }
                            {
                                //<Form.Check key={idx}
                                //    type="radio"
                                //    label={opt.optText}
                                //    name={this.props.name}
                                //    checked={this.props.value === opt.optText}
                                //    id={this.props.name}
                                //    feedback="Initial and Revised values cannot be the same."
                                //    value={opt.optText}
                                //    onBlur={this.props.onBlur}
                                //    isInvalid={this.props.value === opt.optText && this.props.error} />
                            }
                        </span>
                    })}
                    <Form.Text className="text-muted">{this.props.description}</Form.Text>
                </Form.Group>
            );
        }
    }
}

export default WorksheetRadioList